import {
  ADD_PAGE_TO_VIEWED,
  LOAD_PAGE_TO_VIEWED,
  RESET_PAGE_TO_VIEWED } from '../../action-types/ui/addPageToViewed';

export const addPageToViewed = pageId => ({
  type: ADD_PAGE_TO_VIEWED,
  pageId,
});

export const loadPageToViewed = state => ({
  type: LOAD_PAGE_TO_VIEWED,
  state,
});

export const resetPageToViewed = () => ({
  type: RESET_PAGE_TO_VIEWED,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/addPageToViewed.js